import React from 'react';
import Redirect from './Redirect';
import { IRouterProps } from './types';

interface INoMatchProps extends IRouterProps {
  redirectTo: string;
}

const NoMatch: React.FC<INoMatchProps> = ({ redirectTo }) => (
  <Redirect noThrow to={redirectTo} />
);

export default NoMatch;
